<template>
  <div
    class="relative"
    :class="[width, height]"
    ref="container"
  >
    <!-- Image -->
    <img
      v-if="isVisible"
      :src="src"
      :alt="alt"
      @load="onLoad"
      @error="onError"
      :class="[
        'w-full h-full object-cover transition-opacity duration-500',
        loaded ? 'opacity-100' : 'opacity-0',
        innterClass
      ]"
    />

    <!-- Spinner -->
    <div
      v-if="!loaded"
      class="absolute inset-0 flex items-center justify-center bg-gray-100 dark:bg-gray-800"
    >
      <div class="animate-spin rounded-full h-8 w-8 border-4 border-t-transparent border-blue-500"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps<{
  src: string
  alt?: string
  width?: string // e.g. 'w-64', 'w-full'
  height?: string // e.g. 'h-40', 'h-full'
  innterClass?: string // e.g. 'h-40', 'h-full'
}>()

const container = ref<HTMLElement | null>(null)
const loaded = ref(false)
const isVisible = ref(false)

let observer: IntersectionObserver | null = null

function onLoad() {
  loaded.value = true
}

function onError() {
  console.error('Image failed to load:', props.src)
}

onMounted(() => {
  if ('IntersectionObserver' in window && container.value) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            isVisible.value = true
            observer?.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1 }
    )
    observer.observe(container.value)
  } else {
    isVisible.value = true
  }
})

onBeforeUnmount(() => {
  observer?.disconnect()
})
</script>
